<template>
    <v-layout>
         <!-- Apply for PC or Laptop -->
        <v-container class="hidden-sm-and-down">
            <v20a7000pc/>
        </v-container>
        <!-- Apply for Mobile -->
        <v-container class="hidden-md-and-up">
            <v20a7000m/>
        </v-container>
    </v-layout>    
</template>

<script>

import v20a7000m from './popup/v20a7000m'
import v20a7000pc from './popup/v20a7000pc'


export default {
    
    name: "v20a7000",
    components: {
       v20a7000m,
       v20a7000pc 
    },
    props:{
       
    },
    data: () => ({  
       

    }),    
    mounted() {

     
    },
    methods : {

    }

    
}
</script>